import React, { useState, useMemo, useEffect } from 'react';
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import { DialogPdf } from '../../pures';

const FollowUpDocumentPDF = (props) => {
    const {
        urlSelected
    } = props

    const [urlPdf, setUrlPdf] = useState('')
    const [blobAWS, setBlobAWS] = useState('');

    useEffect(() => {
        setUrlPdf(urlSelected)
        setBlobAWS(urlSelected)
    }, [urlSelected])

    const pdf = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={true} isSSRActive={false} />, [urlPdf])

    return (
        <div className='followUpDocumentEntities-documentPDF' >
            <div className='followUpDocumentEntities-documentPDF-container'>
                {pdf}
            </div>
            <div className="followUpDocumentEntities-documentPDF-pdf-btn">
                <DialogPdf blobUrl={blobAWS} />
            </div>
        </div>
    )
}

export { FollowUpDocumentPDF as default }